import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const b2bEnterpriseTemplate: FunnelTemplate = {
  id: "b2b-enterprise",
  serviceLine: "SEO",
  recommendedBands: ["enterprise"],
  pdfAccentColor: "#0f172a",
  defaultTrafficChannels: [
    { id: "linkedin",         label: "LinkedIn Organic",    monthlyVisitors: 300, acquisitionType: "organic" },
    { id: "linkedin_ads",     label: "LinkedIn Ads",        monthlyVisitors: 200, acquisitionType: "cpc", cpc: 8.5 },
    { id: "google_ads",       label: "Google Ads",          monthlyVisitors: 250, acquisitionType: "cpc", cpc: 5.0 },
    { id: "email_newsletter", label: "Email Newsletter",    monthlyVisitors: 150, acquisitionType: "organic" },
    { id: "referral",         label: "Referral / Partners", monthlyVisitors: 100, acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "awareness", conversionRate: 100, isEditable: false, stageType: "blog-post" },
    { id: "content",   conversionRate: 8,   isEditable: true,  stageType: "landing-page" },
    { id: "mql",       conversionRate: 12,  isEditable: true,  stageType: "opt-in-page" },
    { id: "sql",       conversionRate: 30,  isEditable: true,  stageType: "email-sequence" },
    { id: "demo",      conversionRate: 50,  isEditable: true,  stageType: "discovery-call" },
    { id: "proposal",  conversionRate: 45,  isEditable: true,  stageType: "proposal" },
    { id: "close",     conversionRate: 30,  isEditable: true,  stageType: "retainer-close" },
  ],
};
